<div class="container my-4">
  <div class="row">
    <div class="col-12">
      <span class="title_header_bar">Manage Sales Rep</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row d-flex  align-items-center flex-wrap grid-margin mb-3">
      <div class="col-md-4">
        <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
          <i class="fa fa-refresh"></i> Refresh
        </button> -->
        <app-button (refreshClicked)="clearFilter()"></app-button>

        <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
          <i class="fa fa-file-excel"></i> Export
        </button>
        <button type="button" class="btn btn-primary text-nowrap" (click)="gotoProductSub(0)">
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
      <div class="col-md-5 padd-right-file" style="display: flex;">
        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
          <mat-label>Search</mat-label>
          <div class="search-input-container">
            <input placeholder="Enter Customer Number / Application / Name / Contact Number" id="search" matInput
              (keydown.enter)="getTableData(filterValue)" (keyup)="applyFilter($event)" type="text" #searchInput>
          </div>
        </mat-form-field>
        <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
          (click)="getTableData(filterValue)">
          <mat-icon style="color: white;">search</mat-icon>
        </button>
      </div>
  
    </div>
    <div class="table-responsive mt-2 mb-4">
      <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
        <ng-container matColumnDef="salesRepName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="salesRepName">Sales Rep Name</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.salesRepName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="salesRepCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header="salesRepCode">Sales Rep Code</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.salesRepCode}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <div class="text-truncate text-center">
              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                (click)="gotoProductSub(dataField.id)"></i>

              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can"
                (click)="deleteUser(dataField)"></i>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
      </mat-table>
    </div>
    <div *ngIf="data.length===0" class="text-center">
        No Results Found
      </div>
      <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
        <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
            [pageSizeOptions]="[50, 100]">
        </mat-paginator>
    </div>
  </div>
</div>
